<button
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="menuOpen($event)"
  class="flex items-center text-fg-secondary hover:text-fg-primary focus:outline-none focus:text-fg-primary"
  aria-label="Options"
  id="options-menu"
  aria-haspopup="true"
  aria-expanded="true"
  type="button"
>
  <ng-content select="app-dropdown-button"></ng-content>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'none'"
  (backdropClick)="isOpen = false"
  (detach)="isOpen = false"
>
  <div>
    <div class="mt-2 w-56 rounded-md border border-edge shadow-xl z-50 max-h-80 overflow-y-auto">
      <div class="rounded-md bg-surface ring-1 ring-black/5">
        @if (dropdownHeader) {
          <div class="px-4 py-3">
            <p class="text-sm leading-5 font-medium text-fg-primary truncate">
              {{ dropdownHeader }}
            </p>
          </div>
          <div class="border-t border-edge"></div>
        }

        @if (hasSearch) {
          <div>
            <input
              appSelectAll
              appTailwindInput2
              class="m-2 p-2 w-4/5"
              placeholder="suche..."
              (input)="searchValue($event)"
            />
          </div>
        }

        <div
          class="py-2 divide-y divide-separator"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <ng-content select="app-dropdown-item"></ng-content>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-template>
